import { InfoChipColor, InfoChipType } from '../info-chip/info-chip.types';

export type MunilyNestedResourceCardStatusConfig = {
  label: string;
  color?: InfoChipColor;
  type?: InfoChipType;
};

export type MunilyNestedResourceCardData = {
  title: string;
  imageUrl?: string | null;
  showPrice?: boolean;
  /**
   * Línea de precio monolítica (retrocompat). Preferir `priceHeading` + `currencySymbol` + `priceAmount`.
   */
  priceLabel?: string;
  /** Texto antes del símbolo, p. ej. "Precio:" / "Price:" */
  priceHeading?: string;
  /** Símbolo o código de moneda mostrado junto al importe (p. ej. `$`, `COP`). */
  currencySymbol?: string;
  /** Importe formateado o texto de “sin definir”, sin moneda. */
  priceAmount?: string;
  /**
   * Unidad de cobro junto al importe (p. ej. `/ hora`, `fijo`).
   * Solo aplica al layout split (`priceHeading` + `priceAmount`).
   */
  priceUnitLabel?: string;
  status?: MunilyNestedResourceCardStatusConfig;
  ariaLabel?: string;
};

export const MUNILY_NESTED_RESOURCE_CARD_DEFAULTS: Required<
  Pick<MunilyNestedResourceCardData, 'showPrice'>
> = {
  showPrice: true,
};

